import React from 'react'
import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

export const AISuggestionButton = ({
    onClick,
    loading = false,
    disabled = false,
    buttonText = "Suggested by AI",
    customIcon = null,
    suggestions = []
}) => {
    if (!suggestions.length && !loading) {
        return null
    }

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            className={cn(
                'tw:flex tw:items-center tw:p-1 tw:text-blue-400',
                'hover:tw:text-blue-300 tw:transition-colors tw:border-0 tw:bg-transparent',
                'disabled:tw:opacity-50 disabled:tw:cursor-not-allowed',
                'focus:tw:outline-none'
            )}
            title="AI Suggestions"
        >
            {customIcon || <Sparkles size={14} />}
            {loading && buttonText && <span className="tw:ml-1 tw:text-xs">{loading ? 'Loading...' : buttonText}</span>}
        </button>
    )
}